<template>
  <el-dialog title="修改余额" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form size="small" ref="changeform" :model="changeform" :rules="formRules" :label-width="formLabelWidth">
      <el-form-item label="当前余额" :label-width="formLabelWidth">
        <el-input v-model="form.money" autocomplete="off" disabled="disabled"></el-input>
      </el-form-item>
      <el-form-item label="充值方式" :label-width="formLabelWidth">
        <el-radio-group v-model="changeform.mode">
          <el-radio label="inc">增加</el-radio>
          <el-radio label="dec">减少</el-radio>
          <el-radio label="final">最终金额</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="变跟金额" :label-width="formLabelWidth">
        <el-input v-model="changeform.money" autocomplete="off" placeholder="请输入变更金额"></el-input>
      </el-form-item>
      <el-form-item label="管理员备注" :label-width="formLabelWidth">
        <el-input type="textarea" v-model="changeform.remark" placeholder="请输入管理员备注"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Technician from "@/api/technician.js";
export default {
  data() {
    return {
      changeform: {
        mode:"inc",
        money: "",
        remark: "",
        waiter_user_id: ""
      },
      /*左边长度*/
      formLabelWidth: "120px",
      /*是否显示*/
      loading: false,
      dialogVisible: false,
      /*form验证*/
      formRules: {
        money: [
          {
            required: true,
            message: " ",
            trigger: "blur"
          }
        ],
        remark: [
          {
            required: true,
            message: " ",
            trigger: "blur"
          }
        ]
      }
    };
  },
  props: ["open_balance", "form"],
  created() {
    console.log(this.form.waiterUserId,this.open_balance);
    this.dialogVisible = this.open_balance;
    this.changeform.waiter_user_id= this.form.waiterUserId;
  },
  methods: {
    onSubmit() {
      let self = this;
      if (this.changeform.money == '' &&  this.changeform.remark == '') {
        self.$message({
          message: "请将信息完善后在提交！",
          type: "error"
        });
        return;
      }
      console.log(self.changeform);
      self.loading = true;
      Technician.recharge(self.changeform, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: "恭喜你，修改成功",
            type: "success"
          });
          self.dialogFormVisible(true);
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit("closeDialog", {
          type: "success",
          openDialog: false
        });
      } else {
        this.$emit("closeDialog", {
          type: "error",
          openDialog: false
        });
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/technician/technicianlist/dialog/changebalance.vue